import { apiClient } from './base';

export const getProfile = async () => {
  const response = await apiClient.get('/profile');
  return response.data;
};

export const updateProfile = async (formData) => {
  const response = await apiClient.put('/profile', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await apiClient.put('/profile/password', { currentPassword, newPassword });
  return response.data;
};
